import React from 'react'
import './styles/AboutCard.css'
import aboutOne from '../assets/images/community.webp'
import aboutTwo from '../assets/images/mission.webp'
import aboutThree from '../assets/images/vision.webp'

import useMediaQuery from '../hooks/useMediaQuery.js'

const AboutCard = ({ rowType, imageType, headerContent, children }) => {
  const isResponsive = useMediaQuery(950)

  const findImageSource = () => {
    switch (imageType) {
      case 'about1':
        return aboutOne;
      case 'about2':
        return aboutTwo;
      case 'about3':
        return aboutThree;
    }
  }

  // Determines the row type for the about cards
  const determineRowType = () => {

    if (isResponsive) {
      return rowType === 'row' ? 'column' : 'column'
    } else {
      return rowType
    }
  }

  return (
    <div className='about-card' style={{ flexDirection: determineRowType() }}>
      <div className='image' style={{ justifyContent: determineRowType() === 'row' ? 'flex-start' : 'flex-end' }}>
        <img id={'image-card-' + imageType} className='image-card' src={findImageSource()} />
      </div>
      <div className='text'>
        <h2>{headerContent}</h2>
        {children}
      </div>
    </div>
  )
}

export default AboutCard
